import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {playButtonTap,playMainMusic,stopMainMusic} from './PlaySounds';

class SettingsScreen extends Component {

    musicONOff = () =>{
      playButtonTap();
      if(localStorage.getItem('musicon') === "0"){
          localStorage.setItem('musicon',1);
          playMainMusic();
      }else{
          localStorage.setItem('musicon',0);
          stopMainMusic();
      }
      this.forceUpdate();
    }
    soundOnOff = () =>{
      playButtonTap();
      if(localStorage.getItem('soundon') === "0"){
        localStorage.setItem('soundon',1);
    }else{
        localStorage.setItem('soundon',0);
    }
    this.forceUpdate();
    }

    goToMainMenu = () => {
      playButtonTap();
      this.props.history.push('/mainmenu');
  };
    

    render() {
      var title = ""
      var direction = "";
      var soundsText = "";
      var musicText = "";
      var musicSwitch = "";
      var soundSwitch = "";
      if(localStorage.getItem('musicon') === "1" || localStorage.getItem('musicon') == null){
        musicSwitch = "switch_on.png"
      }else{
        musicSwitch = "switch_off.png"
      }
      
      if(localStorage.getItem('soundon') === "1" || localStorage.getItem('soundon') == null){
        soundSwitch = "switch_on.png"
      }else{
        soundSwitch = "switch_off.png"
      }


      if(this.props.language === "en"){
           title = "Settings";
           soundsText = "Sounds";
           musicText =  "Music"
           direction = "ltr";
      }else if(this.props.language === "ur"){
          title = "ترتیبات"
          soundsText = "آوازیں";
          musicText = "Music"
          direction = "rtl";
      }
            return(
                <div className = "screen_background popup_top_padding">
                  <div dir={direction} className = "setting_title">
                        {title}
                  </div>
                  <div className = "setting_popup">
                    
                    <div dir={direction} className= "settings_button_wrapper">
                      <div>
                        <span className = "settings_button_text">{musicText}</span>
                        <img className = "settings_button" src={"/game-skins/build-rev23-3HSR1vhO1/images/"+musicSwitch} alt="" onClick = {this.musicONOff}/>
                      </div>
                      <div>
                        <span className = "settings_button_text">{soundsText}</span>
                        <img className = "settings_button" src={"/game-skins/build-rev23-3HSR1vhO1/images/"+soundSwitch} alt="" onClick = {this.soundOnOff}/>
                      </div>
                          
                    </div>
                  </div>
                  <img src={"/game-skins/build-rev23-3HSR1vhO1/images_"+this.props.language+"/btn_back.png"} alt="" className="button" onClick = {this.goToMainMenu}/>
                </div>
            )
    }
}

SettingsScreen.propTypes = {
  language:PropTypes.string.isRequired
}
const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en")
});
export default connect(mapStateToProps)(SettingsScreen);
//export default withRouter(IntroScreen);



// WEBPACK FOOTER //
// ./src/components/SettingsScreen.js